import React from 'react';
import __ from 'utils/i18n'

export const PaginatorInfoComponent = ({from, to, total}) => {
  return (
    <div className='paginatorInfoContainer'>
      <p>{from} - {to > total ? total : to} {__('dashboard.paginator.of')} {total} </p>
    </div>
  )
}